module.exports = __webpack_public_path__ + "static/media/ride_flex_logo_login.ce8fd7c9.svg";